import React from "react";
import instagram_img from "../assets/images/instagram.svg";
import playStore_img from "../assets/companylogo/playStore.png";
import { Link } from "react-router-dom";
import ScrollToHomeLink from "./ScrollToHome";

const footerData = [
  {
    title: "Quick Links",
    links: [
      { label: "Compare Rates", href: "/" },
      { label: "Remittance Guide", href: "/guide" },
      {
        label: "Best Transfer Providers",
        href: "/comparison/worldremit-vs-wise",
      },
      { label: "FAQ", href: "/faq" },
      { label: "Blogs", href: "/blogs" },
    ],
  },
  {
    title: "Contact Us",
    links: [{ label: "Contact Us", href: "/contact" }],
  },
  {
    title: "Legal & Compliance",
    links: [
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms & Condition", href: "/terms-condition" },
      { label: "Affiliate Disclaimer", href: "/affiliate-disclaimer" },
    ],
  },
];

const socialLinks = [
  {
    img : playStore_img,
    alt : "google play",
    url : "https://play.google.com/store/apps/details?id=com.money.ratefinder&pcampaignid=web_share"
  },
  {
    img: instagram_img,
    alt: "Instagram",
    url: "https://www.instagram.com/moneyratefinder?igsh=MXdsZGc1ZzZzcWQ4eg%3D%3D&utm_source=qr",
  },
  // { img: linkedin_img, alt: "LinkedIn", url: "https://www.linkedin.com" },
  // { img: twitter_img, alt: "Twitter", url: "https://www.twitter.com" },
];

const Footer = ({ classes }) => {
  return (
    <footer className={`${classes} bg-[#6C33B5] text-white py-8`}>
      <div className="container mx-auto px-4 lg:px-8">
        {/* Heading & Description */}
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4">
          Money Rate Finder
        </h2>
        <div className="mb-8">
          <h2 className="text-lg sm:text-xl md:text-3xl font-semibold mb-2">
            Smarter Choices for Global Transfers
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-300 font-medium">
            Since our inception, Money Rate Finder has been committed to making
            international money transfers more transparent and hassle-free. We
            believe sending money across borders should be effortless, secure,
            and cost-effective.
          </p>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {footerData.map((section, index) => (
            <FooterSection
              key={index}
              title={section.title}
              links={section.links}
            />
          ))}
        </div>

        {/* Divider */}
        <hr className="border-gray-600 my-6" />

        {/* Footer Bottom Section */}
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm sm:text-base md:text-lg text-gray-300 font-medium">
            © 2025 Money Rate Finder. All Rights Reserved.
          </p>

          {/* Social Media Links */}
          <div className="flex gap-4 items-center">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center"
              >
                <img
                  src={social.img}
                  alt={social.alt}
                  className={`${social.alt === "google play" ? "w-36 h-auto" : "w-6 h-6"
                  } hover:opacity-75 cursor-pointer`}
                />
              </a>
            ))}
          </div>


        </div>
      </div>
    </footer>
  );
};

/** Reusable Footer Section Component */
const FooterSection = ({ title, links }) => (
  <div>
    <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-4">{title}</h3>
    <ul className="space-y-2">
      {links.map((link, index) => (
        <li key={index}>
          {link.label === "Compare Rates" ? (
            <ScrollToHomeLink className="text-sm sm:text-base md:text-lg text-gray-300 hover:text-white font-medium">
              {link.label}
            </ScrollToHomeLink>
          ) : (
            <Link
              to={link.href}
              className="text-sm sm:text-base md:text-lg text-gray-300 hover:text-white font-medium"
            >
              {link.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
